
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/context-hub/external",
      function () {
        return require("private-next-pages/context-hub/external.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/context-hub/external"])
      });
    }
  